import { IDeviceRepository } from '../infrastructure/Interfaces';
import { DeviceRepository } from '../infrastructure/Repositories';

export interface IDIContext {
  deviceRepository: IDeviceRepository;
}

export const DIContext: IDIContext = {
  deviceRepository: DeviceRepository,
};
